import { BaseFetch } from "../main-model"
export default class TempleModel extends BaseFetch {
    getTempleBy = (data) =>
    this.authFetch({
      url: "temple/getTempleBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getTempleById = (data) =>
    this.authFetch({
      url: "temple/getTempleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateTempleById = (data) =>
    this.authFetch({
      url: "temple/updateTempleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertTemple = (data) =>
    this.authFetch({
      url: "temple/insertTemple",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteTempleById = (data) =>
    this.authFetch({
      url: "temple/deleteTempleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertTempleWithDistrict = (data) =>
    this.authFetch({
      url: "temple/insertTempleWithDistrict",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateTempleWithDistrict = (data) =>
    this.authFetch({
      url: "temple/updateTempleWithDistrict",
      method: "POST",
      body: JSON.stringify(data),
    })
}
